import { render, staticRenderFns } from "./umumkan.vue?vue&type=template&id=6196eab6&"
import script from "./umumkan.vue?vue&type=script&lang=js&"
export * from "./umumkan.vue?vue&type=script&lang=js&"
import style0 from "./umumkan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports